import React from 'react';

//import data
import { ctaData } from "../data";

//import React Icons
import { BsArrowRight } from 'react-icons/bs';

const CtaSection = () => {

    const { title, subtitle, btnText1, btnText2 } = ctaData;
    return (
        <section className="my-[75px] xl:my-[150px] border-t-2" data-aos='fade-up'>
            <div className="container mx-auto">
                <div className="flex flex-col xl:flex-row justify-between items-center">
                    {/* Text */}
                    <div className="py-12 xl:py-24 text-center xl:text-left">
                        <h2 data-aos='fade-up' data-aos-delay='300' className="h2 mb-5">{title}</h2>
                        <p className="lead">{subtitle}</p>
                    </div>

                    {/* buttons */}
                    <div className='flex flex-col xl:flex-row gap-y-4 gap-x-[30px]'>
                        <button data-aos='fade-up' data-aos-delay='300' className="btn btn-secondary">{btnText1}</button>
                        <button className="btn btn-quaternary flex items-center gap-x-[20px] group">
                            {btnText2} <BsArrowRight className="text-2xl text-accent-primary group-hover:text-white transition" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CtaSection
